import { AlmeUIMessage } from '@alme/ui-web/types/response';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import * as actions from '../actions/actions'

export default class ResponseHandler {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    doesHandle(message: AlmeUIMessage) {
        return message.messageType === this._settings.messageConstants.extensibleRequest &&
            message.messageSource === this._settings.initializationData.accessKeyMessageSourceName;
    }

    process(message: AlmeUIMessage) {
        if (!this.doesHandle(message)) return message;

        let accessKey = message.response;
        if(accessKey !== null && accessKey !== undefined && this._store){
            let accessKeyLocation = `${this._settings.stateLocations.Conversation.Base}.${this._settings.stateLocations.Conversation.accessKey}`
            let accessKeyInput = {
                "accessKey": accessKey,
                "stateLocation":accessKeyLocation
            }
            this._store.dispatch(actions.saveAccessKey(accessKeyInput));

            let stateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.productPayload.Base}`;
            //@ts-ignore
            let productPayload = this._store?.getState()?.[this._settings.stateLocations.Window.Base]?.[this._settings.stateLocations.Window.productPayload.Base];
            if(productPayload !== null && productPayload !== undefined){
                productPayload.accessKey = accessKey;
                let productSavedLocation = this._settings.stateLocations.Window.productPayload.payloadSaved;

                //  save product info payload when this function called
                this._store.dispatch(actions.saveProductPayload(productPayload, stateLocation, productSavedLocation));
            }
        }
        return message;
    }

}


// WEBPACK FOOTER //
// ./modules/access-key-processor/message-handlers/response.ts